// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"c7ea5e8da43af000","983":"1bcfc122b5735c37"}[chunkId] + ".js";
};